import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { ResponsiveFunnel } from '@nivo/funnel';
import { useQuery } from '@tanstack/react-query';
import {
  BDM_CARD_SX,
  BDM_CHART_HEIGHT,
  BDM_PANEL_HEIGHT,
  CeoChartSlot,
  CeoDashboardPanel,
} from '../../pages/ceo/ceoDashboardLayout';
import { fetchCeoEnquiryPipeline } from '../../services/ceoReportingService';

/**
 * @param {{ onStageClick?: (stage: string) => void }} props
 */
export default function EnquiryPipelineFunnel({ onStageClick }) {
  const pipelineQuery = useQuery({
    queryKey: ['ceoEnquiryPipeline'],
    queryFn: fetchCeoEnquiryPipeline,
    staleTime: 60_000,
  });

  const stages = pipelineQuery.data?.stages || [];
  const funnelData = stages.map((s) => ({
    id: s.id,
    value: s.value,
    label: `${s.label} (${s.value})`,
    color: s.color,
  }));

  return (
    <CeoDashboardPanel
      title="Enquiry Pipeline Status"
      subtitle="Current enquiries by stage — click a segment for records"
      icon={TrendingUpIcon}
      height={BDM_PANEL_HEIGHT}
    >
      <CeoChartSlot height={BDM_CHART_HEIGHT}>
        {pipelineQuery.isLoading ? (
          <Skeleton variant="rectangular" width="100%" height={BDM_CHART_HEIGHT} />
        ) : funnelData.length > 0 ? (
          <Box sx={{ width: '100%', height: BDM_CHART_HEIGHT }}>
            <ResponsiveFunnel
              data={funnelData}
              margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
              valueFormat=">-.0f"
              colors={{ datum: 'color' }}
              borderWidth={20}
              labelColor="#ffffff"
              enableLabel
              currentPartSizeExtension={10}
              currentBorderWidth={40}
              motionConfig="gentle"
              onClick={(part) => {
                if (onStageClick && part?.data?.id) {
                  onStageClick(String(part.data.id));
                }
              }}
              theme={{
                labels: {
                  text: {
                    fontSize: 12,
                    fontWeight: 600,
                    fill: '#000000',
                  },
                },
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              height: BDM_CHART_HEIGHT,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              color: 'text.secondary',
            }}
          >
            <TrendingUpIcon sx={{ fontSize: 48, opacity: 0.5 }} />
            <Typography variant="body1">No active opportunities in pipeline</Typography>
          </Box>
        )}
      </CeoChartSlot>
    </CeoDashboardPanel>
  );
}

export { BDM_PANEL_HEIGHT as FUNNEL_PANEL_HEIGHT, BDM_CARD_SX };
